<template>
    <div class="block-academies" :style="getBlockAcademiesStyle" v-if="detail.conditions?.value">
        <div>
            <z-caption tag="h3" class="block-academies__title">{{ detail.conditions?.description }}</z-caption>
           <!-- <ul class="u-gap--s u-flex u-flex-col">
                <li v-for="(item, index) in detail.conditions.value" :key="index">
                    <z-icon
                        width="24"
                        height="24"
                        name="list/star"/>
                    {{ item }}
                </li>
            </ul>-->
            <vue-raw :raw="detail.conditions?.value"></vue-raw>
        </div>
        <z-video
            class="block-academies__video"
            v-if="detail.video?.value"
            :src="detail.video?.value"
            :autoplay="false"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    list: {
        type: Array
    },
    bgImage: {
        type: String,
        default: '/media/img/bg-block-academies.png'
    },
    video: {
        type: String
    },
    detail: {
        type: Object
    },

})

const getBlockAcademiesStyle = computed(() => {
    return `background-image: url('${ props.bgImage }')`
})

</script>

<style lang="scss">
.block-academies {
    padding: var(--spacer-l) var(--spacer-xl);
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 20px;
    background-size: cover;
    background-repeat: no-repeat;

    @include breakpoint(v-tablet) {
        flex-direction: column;
    }

    &__title {
        font-size: var(--typography-lt);
    }

    &__video {
        max-height: 377px;
        max-width: 550px;
        border-radius: 20px;
        margin-left: 20px;
        flex-shrink: 0;

        @include breakpoint (v-tablet) {
            margin-top: var(--spacer-m);
            margin-left: 0;
        }
    }

    ul {
        margin: 0;
    }

    li {
        padding-bottom: var(--spacer-m);
        padding-top: var(--spacer-m);
        border-bottom: 1px solid var(--color-graph-base);

        .z-icon{
            margin-right: var(--spacer-2xs);
        }
    }
}
</style>
